﻿import {ErrorBundle, errorToErrorBundle, translation} from "@2d-front-monorepo/core";
import {JSX} from "react";

export default function ErrorDetail({error}: { error: Error | ErrorBundle }): JSX.Element {
	let bundle: ErrorBundle;
	if (error instanceof Error) {
		bundle = errorToErrorBundle(error);
	} else {
		bundle = error;
	}

	return (
		<>
			{bundle.detail ? <p>{translation(bundle.detail)}</p> : null}
			{bundle.errors.length > 0 ?
				<ul>
					{bundle.errors.map((error, index) =>
						<li key={index}>{translation(error)}</li>)
					}
				</ul>
				: null}
			{bundle.footer ? <div><small>{translation(bundle.footer)}</small></div> : null}
		</>
	);
}
